import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/solid";
import React from "react";

export default function Pagination({
  pages,
  currentPage,
  changePageCallback,
  totalRecords,
  recordsPerPage,
  changeDisplayRecordCountCallback,
}) {
  // const threshold = parseInt(pages / 10);
  const ref = React.useRef(null);

  const scrollLeft = (scrollOffset = 150) => {
    ref.current.scrollLeft -= scrollOffset;
  };
  const scrollRight = (scrollOffset = 150) => {
    ref.current.scrollLeft += scrollOffset;
  };
  return (
    <div className='bg-white px-4 py-3 flex items-center justify-between border-t border-gray-100 sm:px-6'>
      <div className='flex-1 flex justify-between visible sm:hidden'>
        {currentPage !== 0 ? (
          <button
            onClick={(e) => {
              e.preventDefault();
              changePageCallback(currentPage - 1);
            }}
            className='relative inline-flex items-center px-4 py-2 border border-gray-300 text-xs font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50'>
            Previous
          </button>
        ) : (
          <></>
        )}
        <div className='pt-2'>
          <p className='text-xs text-gray-700'>
            Page{" "}
            <span className='font-semibold'>
              {currentPage + 1 + " / " + pages}
            </span>
          </p>
        </div>
        <div>
          <select
            defaultValue={recordsPerPage}
            onChange={(e) => {
              changeDisplayRecordCountCallback(e.target.value);
            }}
            className='block px-1 w-12 border bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 text-xs'>
            <option>5</option>
            <option>10</option>
            <option>20</option>
            <option>25</option>
            <option>50</option>
            <option>100</option>
            <option>500</option>
          </select>
        </div>
        {currentPage < pages - 1 ? (
          <button
            onClick={(e) => {
              e.preventDefault();
              changePageCallback(currentPage + 1);
            }}
            className='ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-xs font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50'>
            Next
          </button>
        ) : (
          <></>
        )}
      </div>
      <div className='w-full sm:flex space-x-4 justify-between hidden'>
        <div className='flex space-x-4'>
          <p className='text-xs pt-2 text-gray-700'>
            Showing{" "}
            <span className='font-medium'>
              {currentPage * recordsPerPage + 1}
            </span>{" "}
            {(currentPage + 1) * recordsPerPage < totalRecords ? (
              <span className='font-medium'>
                to&nbsp;
                {(currentPage + 1) * recordsPerPage < totalRecords
                  ? (currentPage + 1) * recordsPerPage
                  : totalRecords}
                &nbsp;
              </span>
            ) : (
              <span className='font-medium'>
                to&nbsp;
                {totalRecords}
                &nbsp;
              </span>
            )}
            of <span className='font-medium'>{totalRecords}</span> results
          </p>

          <div>
            <select
              defaultValue={recordsPerPage}
              onChange={(e) => {
                changeDisplayRecordCountCallback(e.target.value);
              }}
              className='block w-12 px-2 border bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-xs'>
              <option>5</option>
              <option>10</option>
              <option>20</option>
              <option>25</option>
              <option>50</option>
              <option>100</option>
              <option>500</option>
            </select>
          </div>
        </div>
        <div className='flex space-x-4'>
          <div className='pt-3'>
            <p className='text-xs text-gray-700'>
              Total pages <span className='font-semibold'>{pages}</span>
            </p>
          </div>
          <nav
            className='relative z-0 inline-flex rounded-md shadow-sm -space-x-px duration-300 '
            aria-label='Pagination'>
            <button
              onClick={(e) => {
                // e.preventDefault();
                // changePageCallback(currentPage - 1);
                scrollLeft();
              }}
              className='relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-gray-50 text-xs font-medium text-gray-500 hover:bg-gray-50'>
              <span className='sr-only'>Previous</span>
              <ChevronLeftIcon className='h-5 w-5' aria-hidden='true' />
            </button>

            <div
              className='max-w-sm border-0 border-yellow flex overflow-x-hidden hover:overflow-x-auto scroll-smooth'
              ref={ref}>
              {[...Array(pages)].map(
                (x, i) => (
                  // pages > 5 ? (
                  //   ((currentPage >= i && currentPage <= i + 2) ||
                  //     i === pages - 1 ||
                  //     i === 0) && (
                  //     <button
                  //       key={i}
                  //       aria-current='page'
                  //       onClick={(e) => {
                  //         e.preventDefault();
                  //         changePageCallback(i);
                  //       }}
                  //       className={`${
                  //         currentPage === i
                  //           ? "z-10 bg-yellow-50 border-yellow text-yellow-2 font-semibold"
                  //           : "bg-white border-gray-300 text-gray-500 hover:bg-gray-50 font-medium"
                  //       } relative inline-flex items-center px-4 py-2 border text-xs `}>
                  //       {i + 1}
                  //     </button>
                  //   )
                  // ) : (
                  <button
                    key={i}
                    aria-current='page'
                    onClick={(e) => {
                      e.preventDefault();
                      changePageCallback(i);
                    }}
                    className={`${
                      currentPage === i
                        ? "z-10 bg-yellow-50 border-yellow text-yellow-2 font-semibold"
                        : "bg-white border-gray-300 text-gray-500 hover:bg-gray-50 font-medium"
                    } relative inline-flex items-center px-4 py-2 border text-xs `}>
                    {i + 1}
                  </button>
                ),
                // ),
              )}
            </div>
            {currentPage < pages - 1 && (
              <button
                onClick={(e) => {
                  // e.preventDefault();
                  // changePageCallback(currentPage + 1);
                  scrollRight();
                }}
                className='relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-xs font-medium text-gray-500 hover:bg-gray-50'>
                <span className='sr-only'>Next</span>
                <ChevronRightIcon className='h-5 w-5' aria-hidden='true' />
              </button>
            )}
          </nav>
        </div>
      </div>
    </div>
  );
}
